import ZeusProvider from "components/ZeusProvider";

export const wrapRootElement = ({ element }) => (
  <ZeusProvider>{element}</ZeusProvider>
);

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.state && location.state.scrollToArticles) {
    return false;
  }

  return true;
};
